// dependencies
import { Map } from "immutable";
import { connect } from "react-redux";

// component
import { Notifications } from "../../../pages/UserSettings/Views/Notifications/Notifications";

// actions
import {
	init as initAction,
	sendAdminDigestPatch,
	sendAsapAndDeferredPatch,
	sendDeferredTimingPatch,
	sendDigestPatch,
	sendWeeklyAdminDigestTimingPatch,
	sendWeeklyDigestTimingPatch,
	teardown as teardownAction,
	updateActiveSection,
} from "./actions";

import {
	selectAdminWeeklyDigestCompanyNotificationsGroupings,
	selectAsapAndDeferredCompanyNotificationsGroupings,
	selectCompanyAdminDigestDeliverySettings,
	selectCompanyDigestDeliverySettings,
	selectDeferredFrequencyCompanySettings,
	selectWeeklyDigestCompanyNotificationsGroupings,
} from "../../../selectors/settings";
// selectors
import { selectActiveSection, selectIsInitialized, selectRequestingNotifications } from "./selectors";

const mapStateToProps = (state) => {
	const digestNotificationGrouping = selectWeeklyDigestCompanyNotificationsGroupings(state);
	const asapDeferredNotificationGroupings = selectAsapAndDeferredCompanyNotificationsGroupings(state);
	const adminDigestNotificationGrouping = selectAdminWeeklyDigestCompanyNotificationsGroupings(state);

	return {
		userHasAdminDigest: true,
		isTemplate: true,
		activeSection: selectActiveSection(state),
		isInitialized: selectIsInitialized(state),
		requestList: selectRequestingNotifications(state),
		digestNotificationsGroupOrder: digestNotificationGrouping.categories,
		digestNotifications: digestNotificationGrouping.notifications,
		adminDigestNotificationsGroupOrder: adminDigestNotificationGrouping.categories,
		adminDigestNotifications: adminDigestNotificationGrouping.notifications,
		groupOrder: asapDeferredNotificationGroupings.categories,
		asapAndDeferredNotifications: asapDeferredNotificationGroupings.notifications,
		deferredTimesProp: selectDeferredFrequencyCompanySettings(state).toJS(),
		digestDeliverySettings: selectCompanyDigestDeliverySettings(
			state,
			Map({ day: "monday", hour: 12, meridiem: "am" })
		),
		adminDigestDeliverySettings: selectCompanyAdminDigestDeliverySettings(
			state,
			Map({ day: "monday", hour: 12, meridiem: "am" })
		),
	};
};

const mapDispatchToProps = (dispatch) => ({
	init: () => dispatch(initAction()),
	teardown: () => dispatch(teardownAction()),
	updateActiveSection: (sectionName) => dispatch(updateActiveSection(sectionName)),
	updateDigestNotification: (notification, type) => dispatch(sendDigestPatch(notification, type)),
	updateDeferredTimingPatch: (notificationTimes) => dispatch(sendDeferredTimingPatch(notificationTimes)),
	updateAdminDigestNotification: (notification, type) => dispatch(sendAdminDigestPatch(notification, type)),
	updateDigestTimingPatch: (dayOfWeek, hour) => dispatch(sendWeeklyDigestTimingPatch(dayOfWeek, hour)),
	updateAsapAndDeferredNotification: (notification, type) => dispatch(sendAsapAndDeferredPatch(notification, type)),
	updateAdminDigestTimingPatch: (dayOfWeek, hour) => dispatch(sendWeeklyAdminDigestTimingPatch(dayOfWeek, hour)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Notifications);
